import axios from 'axios'

import store from '@/stores'

import Servico from './Servico'

const URL = process.env.VUE_APP_API_URL

class ConvenioServico extends Servico {
  constructor() {
    super('convenio')
  }

  recuperarProcedimentos(filtro) {
    store.setCarregando()
    return axios
      .get(`${URL}/${this.path}/${filtro.convenio}/procedimentos`, {
        params: filtro,
      })
      .then((result) => {
        store.setCarregando()
        return result.data
      })
      .catch((err) => {
        store.setCarregando()
        return this.verificarErro(err)
      })
  }
}

export default ConvenioServico
